import { createSelector } from 'reselect'
import moment from 'moment'

import { supportedShipsByBrand } from '../../configuration/constants'
import {
  selectBrandCode,
  selectShipCode,
  selectDate,
} from '../selections/selectionsSelectors'

export const selectIsValidSearch = createSelector(
  selectBrandCode,
  selectShipCode,
  selectDate,
  (brandCode, shipCode, date) => {
    if (!brandCode || !shipCode || !date) {
      return false
    }
    const supportedShipData = supportedShipsByBrand[brandCode][shipCode]
    const firstValidSearchDate = supportedShipData?.startDate
      ? moment(supportedShipData.startDate)
      : moment()
    return moment(date).isSameOrAfter(firstValidSearchDate)
  },
)
